<template>
  <div class="delete-team-from-tournament-wrapper">
    <h5>Вы действительно хотите удалить <b>{{ params.team && params.team.name }}</b> из Турнира <b>{{ params.tournament && params.tournament.name }}</b>?</h5>
    <h5 class="font-weight-bold mt-3">Укажите причину:</h5>
    <div v-for="reason in reasonsForDelete" :key="'reasonId' + reason.id" class="form-check">
      <input class="form-check-input"
             type="radio" name="reasonsForDelete"
             :id="reason.id"
             v-model="formModel.reject_description"
             :value="reason.text">
      <label class="form-check-label" :for="reason.id">{{reason.text}}</label>
    </div>
    <footer>
      <b-button @click="submitForm" :disabled="isLoadingSaveForm">
        {{ isLoadingSaveForm ? 'Удаляем...' : 'Удалить' }}
      </b-button>
    </footer>
    <b-alert v-if="errorText" show variant="danger" style="margin: 10px 0 0 0">{{ errorText }}</b-alert>
  </div>
</template>

<script>
import {mapState} from "vuex";
import api from "@/api/api";
import {reasonsForDelete} from '@/constants/reasonsForDeleteTeam';
import {clearTeamFromMlbbGrid} from "@/common/clearTeamFromMlbbGrid";

export default {
  name: "DeleteTeamFromTournament",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reasonsForDelete,
      isLoadingSaveForm: false,
      errorText: null,
      formModel: {
        reject_description: ''
      }
    }
  },
  computed: {
    ...mapState('moduleNewTournament', ['selectedGroupId']),
    /**
     * Ручка ждёт id записи tournament_team, а не id команды.
     *
     * Карточки турнира передают его плоским полем, страница заявок — вложенным
     * объектом tournament_team, поэтому забираем из того места, где он есть.
     */
    tournamentTeamId() {
      return this.params.tournamentTeamId
          || this.params.team?.tournament_team_id
          || this.params.team?.tournament_team?.id
    },
    isMlbb() {
      return this.params.tournament?.game?.slug === 'mlbb'
    }
  },
  methods: {
    async submitForm() {
      if (!this.tournamentTeamId) {
        this.errorText = 'Не удалось определить заявку команды в турнире.'
        return
      }

      try {
        this.isLoadingSaveForm = true
        await api.teams.deleteTeamFromTournament(
            this.tournamentTeamId,
            {...(this.formModel.reject_description && {delete_description: this.formModel.reject_description})})
        // Команда снята с турнира — её ячейки во всех сетках турнира становятся пустыми
        if (this.isMlbb) await this.clearGridCells()
        // Страница заявок живёт вне роута сетки: обновлять её стор нечем и незачем.
        const standingId = this.$route.params.standingId
        if (standingId) {
          await this.$store.dispatch('moduleNewTournament/getTournament', {
            id: standingId
          })
          if (this.selectedGroupId)
            await this.$store.dispatch('moduleNewTournament/getTeamsByGroup', { id: this.selectedGroupId })
        }
        this.$emit('submit', this.params.team)
        this.$emit('closeModal')
      } catch (e) {
        const data = e?.response?.data
        const message = data?.message || e?.message || 'Не удалось удалить команду из турнира'
        let errors = ''
        if (data?.errors) errors = Object.entries(data.errors).map(([ name, values ]) => `${ name }: ${ values.join(', ') }`).join('. ')
        this.errorText = `${ message }; ${ errors }.`
      } finally {
        this.isLoadingSaveForm = false
      }
    },
    async clearGridCells() {
      const { failed } = await clearTeamFromMlbbGrid({
        stageIds: (this.params.tournament?.stages || []).map(({ id }) => id),
        teamId: this.params.team?.id
      })
      if (failed) this.$root.$bvToast.toast('Команда снята с турнира, но не из всех матчей сетки — проверьте сетку вручную', {
        title: 'Сетка',
        variant: 'warning',
        solid: true,
        autoHideDelay: 5000
      })
    }
  }
}
</script>

<style scoped lang="scss">
.delete-team-from-tournament-wrapper {
  h5 {
    font-size: 16px;
    font-weight: 400;
  }
  footer {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin-top: 15px;
    text-align: right;
  }
}
</style>